import ReportIssueActivity from './ReportIssueActivity';

export default ReportIssueActivity;
